import React from 'react';
import Paint from "../../images/about/painings.jpg";
import Fadeup from '../fadeup/Fadeup';
import Frame from "../../images/about/paint.jpg";
import Vision from "../../images/about/vis.jpg";
import For from "../../images/about/for.jpeg";

function OurService() {
  return (
   <>
   {/* our mission */}
   <section className='sec_pd'>
     <div className="mt-5 container">
      <div className="row align-items-center  gap-4">
      <div className="col-md-6">
        <Fadeup delay={0.3}>
        <h3 className="text-start mb-4 text-black border-bottom pb-2">Our Mission</h3>
        </Fadeup>
         <Fadeup delay={0.2}>
          <h4 className="text-black fs-5">
          At Anachronistic Auction House, our mission is to safeguard and elevate the enduring legacy
          of cultural artifacts, antiques, and historical treasures. We strive to be the bridge between the
          past and the present—connecting passionate collectors, historians, and enthusiasts with the
          timeless creations that shaped civilizations and carry stories worth preserving.
          </h4>
          <h4 className="text-black fs-5">
          We believe that every artifact holds a voice, a narrative etched into time, waiting to be
          rediscovered and shared. Through meticulous curation, ethical sourcing, and transparent
          transactions, we honor the provenance of each piece, ensuring its journey continues with
          dignity and respect. Our goal is not merely to sell, but to celebrate—keeping history alive by
          placing its most meaningful expressions into appreciative hands.
          </h4>
         </Fadeup>
          
        </div>
      <div className="col-md-5 d-flex justify-content-center">
          {/* <img 
            src={Paint} 
            alt="Our Service" 
            className="about_img floral-border" 
            style={{ maxWidth: '100%', height: 'auto' }}
          /> */}
            <img 
                src={For} 
                alt="About Us" 
                className="about_img" 
                style={{ maxWidth: '70%', height: 'auto' }}
              />
      
        </div>
        {/* Left Side - Content */}
       
        
        {/* Right Side - Image */}
     
      </div>
    </div>
   </section>
   {/* our vision */}
   <section className='sec_pd'>
     <div className="mt-5 container">
      <div className="row align-items-center  gap-4">
      <div className="col-md-5 d-flex justify-content-center">
          {/* <img 
            src={Paint} 
            alt="Our Service" 
            className="about_img floral-border" 
            style={{ maxWidth: '100%', height: 'auto' }}
          /> */}
            <img 
                src={Vision} 
                alt="About Us" 
                className="about_img" 
                style={{ maxWidth: '70%', height: 'auto' }}
              />
      
        </div>
        {/* Left Side - Content */}
        <div className="col-md-6">
        <Fadeup delay={0.3}>
        <h3 className="text-start mb-4 text-black border-bottom pb-2">Our Vision</h3>
        </Fadeup>
         <Fadeup delay={0.2}>
         <h4 className="text-black fs-5">
         Our vision is to become the world’s most trusted and revered auction platform for timeless
         treasures—where history finds a voice, and collectors find meaning beyond the material.
          </h4>
          <h4 className="text-black fs-5">
          We aim to redefine how the world experiences antiques and cultural artifacts by fostering a
          global community built on trust, integrity, and shared appreciation for heritage. As stewards
          of the past, we are committed to promoting education, provenance transparency, and ethical
          acquisition practices—ensuring every piece we present is a testament to authenticity and
          historical significance.
          </h4>
          <h4 className="text-black fs-5">
          By integrating modern technology with old-world reverence, we envision a future where
        cultural appreciation transcends borders, where stories once lost are rediscovered, and where
          every artifact, no matter its origin, is given the platform it deserves to inspire future
          generations.
          </h4>
         </Fadeup>
          
        </div>
        
        {/* Right Side - Image */}
     
      </div>
    </div>
   </section>
   {/* our services */}
   <section className='sec_pd'>
     <div className="mt-5 container">
      <div className="row align-items-center  gap-4">
      <div className="col-md-6">
        <Fadeup delay={0.3}>
          <h3 className="text-start mb-4 text-black border-bottom pb-2">Our Services</h3>
        </Fadeup>

        <Fadeup delay={0.2}>
          <ul className="list-unstyled text-black fs-5">
            <li className="mb-3">
              <strong>Live &amp; Online Auctions:</strong> Real-time bidding through immersive in-person and digital experiences.
            </li>
            <li className="mb-3">
              <strong>Private Sales:</strong> Discreet, curated buying and selling services for high-net-worth individuals and institutions.
            </li>
            <li className="mb-3">
              <strong>Estate Management:</strong> Comprehensive solutions for estate liquidation, inventory documentation, and legacy preservation.
            </li>
            <li>
              <strong>Appraisal &amp; Authentication:</strong> In-house experts and certified third-party specialists provide valuation and provenance verification.
            </li>
          </ul>
        </Fadeup>
      </div>

      <div className="col-md-5 d-flex justify-content-center">
          {/* <img 
            src={Paint} 
            alt="Our Service" 
            className="about_img floral-border" 
            style={{ maxWidth: '100%', height: 'auto' }}
          /> */}
            <img 
                src={Frame} 
                alt="About Us" 
                className="about_img" 
                style={{ maxWidth: '70%', height: 'auto' }}
              />
      
        </div>
        {/* Left Side - Content */}
       
        
        {/* Right Side - Image */}
     
      </div>
    </div>
   </section>
   
   </>
  );
}

export default OurService;
